import { Checkbox, Container, FormControlLabel, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { Helmet } from "react-helmet-async";
import { Status } from "./types";
import NotesModal from "./notes/NotesModal";
import EditStatusModal from "./EditStatusModal";
import { useSearchesNotOrdered } from "./SearchesNotOrderedContext";
import EditETAModal from "./EditETAModal";
import { useEffect, useState } from "react";
import Iconify from "../../minimals/components/iconify";
import { exportTableToCsv } from "../taskUtils";

const statusOptions: Status[] = [
  { fieldDisplayName: "Waiting for Client", value: "None" },
  { fieldDisplayName: "Required", value: "Required" },
  { fieldDisplayName: "Received", value: "Received" },
  { fieldDisplayName: "N/A", value: "NA" }
];

export default function SearchesNotOrdered() {
  const {
    columnFilters,
    isLoading,
    setColumnFilters,
    columnsWithNotes,
    filteredSearchesNotOrdered,
    getRowKey,
    setAssignedToMeOnly,
    selectedRow,
    setSelectedRow,
    unassignedOnly,
    setUnassignedOnly,
    selectedEditRowStatus,
    selectedEditRowETA,
    setSearchesNotOrdered,
    setSelectedEditRowStatus,
    setSelectedEditRowETA,
    newRows,
    assignedToMeOnly
  } = useSearchesNotOrdered();

  const [columnVisibility, setColumnVisibility] = useState(() => {
    try {
      const savedVisibility = localStorage.getItem("searchesNotOrdered_columnVisibility");
      if (savedVisibility) {
        return JSON.parse(savedVisibility);
      }
    } catch (error) {}
    return { department: false, requestDueDate: false, daysSincePlaced: false };
  });

  useEffect(() => {
    localStorage.setItem("searchesNotOrdered_columnVisibility", JSON.stringify(columnVisibility));
  }, [columnVisibility]);

  return (
    <>
      <Helmet>
        <title>Searches Not Ordered | TitleQ</title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" marginBottom={2}>
          Searches Not Ordered
        </Typography>
        <MaterialReactTable
          enableStickyHeader
          columns={columnsWithNotes}
          data={filteredSearchesNotOrdered}
          enableGlobalFilter
          enableFacetedValues
          autoResetPageIndex={false}
          globalFilterFn="includesString"
          getRowId={(row) => getRowKey(row)}
          state={{
            showSkeletons: isLoading,
            showColumnFilters: true,
            columnFilters,
            columnVisibility
          }}
          onColumnFiltersChange={setColumnFilters}
          initialState={{
            density: "compact",
            pagination: { pageIndex: 0, pageSize: 30 }
          }}
          onColumnVisibilityChange={setColumnVisibility}
          muiTableBodyProps={{
            sx: {
              "& .MuiTableRow-root:hover .MuiTableCell-root": {
                backgroundColor: "inherit !important"
              }
            }
          }}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              backgroundColor: newRows.has(row.id) ? "#E9FCD4" : "#fff"
            }
          })}
          renderTopToolbarCustomActions={({ table }) => (
            <>
            <Stack direction="row" spacing={1} width="83%">
              <FormControlLabel
                control={
                  <Checkbox onChange={(e, v) => setAssignedToMeOnly(v)} size="small" checked={assignedToMeOnly} />
                }
                label="Assigned to me"
              />
              <FormControlLabel
                control={<Checkbox onChange={(e, v) => setUnassignedOnly(v)} size="small" checked={unassignedOnly} />}
                label="Unassigned Orders only"
              />
            </Stack>
             <Tooltip title="Export to csv">
             <IconButton onClick={() => exportTableToCsv(table, "export.csv")}>
               <Iconify icon="eva:download-fill" />
             </IconButton>
           </Tooltip>
           </>
          )}
        />
      </Container>
      {selectedRow && (
        <NotesModal
          entity={selectedRow}
          setEntity={setSelectedRow}
          isOpen={true}
          nameBeforeUpdate={selectedRow.assignedTo}
          emailBeforeUpdate={selectedRow.assignedToEmail}
          setEntityTable={setSearchesNotOrdered}
        />
      )}
      {selectedEditRowStatus && (
        <EditStatusModal
          entity={selectedEditRowStatus}
          setEntity={setSelectedEditRowStatus}
          setEntityTable={setSearchesNotOrdered}
          isOpen={true}
          statusOptions={statusOptions}
        />
      )}
      {selectedEditRowETA && (
        <EditETAModal
          entity={selectedEditRowETA}
          setEntity={setSelectedEditRowETA}
          setEntityTable={setSearchesNotOrdered}
          isOpen={true}
          statusOptions={statusOptions}
        />
      )}
    </>
  );
}
